import KindergartenMenu from "../Component/kindergartenMenu";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from '../Component/Footer'
import LazyLoad from 'react-lazyload';
const KidsFeeDetails = () => {
    return (
        <>
         <KindergartenMenu />
            <Breadcrumb title="Yearly Fees Details (Year 2023-2024)" mid="Kindergarten &nbsp; &nbsp;|" tabName="Yearly Fees Details (Year 2023-2024)" />
            <div className="innerPage">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div class="table-responsive table-wid">
                                <table className="table">
                                    <thead>
                                        <tr><th>Class</th>
                                            <th>For year 2023-2024 FEES Approved Tuition Fees by FRC (in rupees)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>NURSERY</td>
                                            <td>49250</td>
                                        </tr>
                                        <tr>
                                            <td>LKG</td>
                                            <td>49250</td>
                                        </tr>
                                        <tr>
                                            <td>HKG</td>
                                            <td>47000</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default KidsFeeDetails;